import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import { convertFertilizerSummaryForLocale, parseDecimals } from 'util/unitConversion';

import { Label } from '@tcc/crate';

import HtmlText from 'html-text/HtmlText';
import ValueWithHeader from 'common/ValueWithHeader';
import { getCategoryDisplayName } from 'util/activities';
const baseString = 'vra-product-summary';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-fertilizer-summary': true
});
const FertilizerSummary = ({ activity, summary }) => {
  const fertilizerStats = summary.map((fertilizerSummary, index) => {
    const { product } = fertilizerSummary;
    const { brand, name } = product;

    const { convertedFertilizerRate, convertedTotalProduct } = convertFertilizerSummaryForLocale(fertilizerSummary);

    const activityText = getCategoryDisplayName(activity.code, activity['category-name']);
    return (
      <div className={`${baseString}__list`} key={`fertilizer-summary-fertilizer-${index}`}>
        <div
          className={`${baseString}__list__item`}
          data-test-id={'fertilizer-timing'}
          key={`fertilizer-summary-product-${index}`}
        >
          <ValueWithHeader
            header={getMessage('text__script-activity-category')}
            testId={'script-fertilizer-activity'}
            value={activityText}
          />
        </div>
        <div
          className={`${baseString}__list__item`}
          data-test-id={'fertilizer-summary-product'}
          key={`fertilizer-summary-product-${index}`}
        >
          <ValueWithHeader
            header={brand}
            nestedBadge={product && product.isCustom ? <Label
              className='custom-chemical-nested-badge'
              status='default'
              testId='crate-label-success-primary'>
              {getMessage('text__use-custom-label-abbrev')}
            </Label> : undefined}
            subheader={getMessage('fertilizer')}
            testId={'script-fertilizer-name'}
            value={name}
          />
        </div>
        <div
          className={`${baseString}__list__item`}
          data-test-id={'fertilizer-summary-average-rate'}
          key={`fertilizer-summary-avg-rate-${index}`}
        >
          <ValueWithHeader
            header={getMessage(`title-text__avg-fertilizer-rate`)}
            testId={'script-fertilizer-average-rate'}
            value={
              <HtmlText
                messageKey={'text__value-with-unit'}
                messageParams={{
                  value: parseDecimals(convertedFertilizerRate.scalarLocaleString),
                  unit: convertedFertilizerRate.symbol.quantitySpecific
                }}
              />
            }
          />
        </div>
        <div
          className={`${baseString}__list__item`}
          data-test-id={'fertilizer-summary-total-product'}
          key={`fertilizer-summary-num-fertilizer-bags-${index}`}
        >
          <ValueWithHeader
            header={getMessage('title-text__total-product')}
            testId={'script-fertilizer-total-rate'}
            value={
              <HtmlText
                messageKey={'text__value-with-unit'}
                messageParams={{
                  value: parseDecimals(convertedTotalProduct.scalarLocaleString),
                  unit: convertedTotalProduct.symbol.quantitySpecific
                }}
              />
            }
          />
        </div>
      </div>
    );
  });

  return <section className={classString}>{fertilizerStats}</section>;
};
FertilizerSummary.propTypes = {
  activity: PropTypes.object,
  summary: PropTypes.array.isRequired
};
export default FertilizerSummary;
